import { calcVisualPos, COL_WIDTH } from "@/utils/utils";
import { memo } from "react";

export const Simuline = memo(function Simuline({ text, shifted, cursor }: { text: string; shifted: boolean; cursor?: boolean }) {
  let chars = text.replaceAll("\t", "    ").split("");
  if (cursor) { chars.push("_"); }
  let visualPos = 1;
  return <>
    {chars.map((char, index) => {
      let adjustClass = calcAdjustClass(visualPos, char);
      visualPos = calcVisualPos(visualPos, char);

      if (char == "\x0F") {
        shifted = false;
      } else if (char == "\x0E") {
        shifted = true;
      } else if (char == "\x07") {
      } else if (char == "\b") {
        return <span className={adjustClass} key={index}></span>;
      } else if (shifted) {
        return <span
          className={`text-red-600 ${adjustClass}`}
          key={index}
        >{char}</span>;
      } else {
        return <span
          key={index}
          className={`${adjustClass}`}
        >{char}</span>;
      }
    })}
  </>;
});

function calcAdjustClass(visualPos: number, char: string) {
  if (visualPos == COL_WIDTH) {
    return "-mr-[0.618em]";
  }
  if (char == "\b" && visualPos > 1) {
    return "-ml-[0.618em]";
  }
  return "";
}

console.assert(calcAdjustClass(1, "a") == "");
console.assert(calcAdjustClass(1, "\b") == "");
console.assert(calcAdjustClass(2, "a") == "");
console.assert(calcAdjustClass(2, "\b") == "-ml-[0.618em]");
console.assert(calcAdjustClass(COL_WIDTH - 1, "a") == "");
console.assert(calcAdjustClass(COL_WIDTH, "a") == "-mr-[0.618em]");
console.assert(calcAdjustClass(COL_WIDTH, "\b") == "-mr-[0.618em]");

